import React from 'react';

import CompetencyAssessment from 'components/Reports/CompetencyAssessment';

export default function index({ match }) {
  const { id } = match.params;

  return <CompetencyAssessment calcContainerId={id} />;
}
